<div class="visible h-[32px] bg-blue-500/5" />
